import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    ADD_MESSAGE: createActionType(FULL_NAMESPACE, "ADD_MESSAGE"),
    CLEAN_MESSAGES: createActionType(FULL_NAMESPACE, "CLEAN_MESSAGES")
};
